/**
 * Interpolation for messages that mention a group by name.
 *
 * A group does not have to have a name, and nothing is invented when it does
 * not: no "unnamed", no course title standing in, no appointment label. What
 * changes instead is the sentence. Every message that quotes a name has an
 * `_unnamed` twin that leaves the name out, and i18next picks it via `context`,
 * so `„{{group}}" verschoben` becomes `Termin verschoben` rather than
 * `„" verschoben`.
 *
 * Spread into the interpolation object:
 *
 *     t('week.undo.moved', { ...groupParams(slot.group_name), day, start, end })
 */
/**
 * The name to show, or null when there is none.
 *
 * Blank counts as none. The API trims a name down to null before storing it,
 * so "   " should not reach us, but a name is only ever read here to decide
 * "show it or leave it out" and the answer for whitespace is the same as for
 * null. Older rows written before the API trimmed are covered too.
 */
export const groupLabel = (name?: string | null): string | null => name?.trim() || null;

export const groupParams = (name?: string | null) => {
    const label = groupLabel(name);

    return {
        group: label ?? '',
        // undefined leaves the base key in play; i18next only looks for the twin
        // when a context is actually given.
        context: label ? undefined : 'unnamed'
    };
};
